import { render, staticRenderFns } from "./BundleItemsCarousel.vue?vue&type=template&id=75afbd18&scoped=true&"
import script from "./BundleItemsCarousel.vue?vue&type=script&lang=js&"
export * from "./BundleItemsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BundleItemsCarousel.vue?vue&type=style&index=0&id=75afbd18&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75afbd18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon})
